"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _abbiategrasso = _interopRequireDefault(require("./15_group_2022_11_09/abbiategrasso"));

var _acquiTerme = _interopRequireDefault(require("./15_group_2022_11_09/acqui-terme"));

var _agnosine = _interopRequireDefault(require("./15_group_2022_11_09/agnosine"));

var _agosta = _interopRequireDefault(require("./15_group_2022_11_09/agosta"));

var _ailano = _interopRequireDefault(require("./15_group_2022_11_09/ailano"));

var _albiano = _interopRequireDefault(require("./15_group_2022_11_09/albiano"));

var _amblarDon = _interopRequireDefault(require("./15_group_2022_11_09/amblar-don"));

var _annoneVeneto = _interopRequireDefault(require("./15_group_2022_11_09/annone-veneto"));

var _arianoNelPolesine = _interopRequireDefault(require("./15_group_2022_11_09/ariano-nel-polesine"));

var _arsie = _interopRequireDefault(require("./15_group_2022_11_09/arsie"));

var _avio = _interopRequireDefault(require("./15_group_2022_11_09/avio"));

var _bagnaria = _interopRequireDefault(require("./15_group_2022_11_09/bagnaria"));

var _bagnoloCremasco = _interopRequireDefault(require("./15_group_2022_11_09/bagnolo-cremasco"));

var _baiaELatina = _interopRequireDefault(require("./15_group_2022_11_09/baia-e-latina"));

var _balestrino = _interopRequireDefault(require("./15_group_2022_11_09/balestrino"));

var _barbianello = _interopRequireDefault(require("./15_group_2022_11_09/barbianello"));

var _barbiano = _interopRequireDefault(require("./15_group_2022_11_09/barbiano"));

var _bertiolo = _interopRequireDefault(require("./15_group_2022_11_09/bertiolo"));

var _berzoDemo = _interopRequireDefault(require("./15_group_2022_11_09/berzo-demo"));

var _bibbiena = _interopRequireDefault(require("./15_group_2022_11_09/bibbiena"));

var _bione = _interopRequireDefault(require("./15_group_2022_11_09/bione"));

var _bolano = _interopRequireDefault(require("./15_group_2022_11_09/bolano"));

var _bolognola = _interopRequireDefault(require("./15_group_2022_11_09/bolognola"));

var _bonemerse = _interopRequireDefault(require("./15_group_2022_11_09/bonemerse"));

var _borgorattoMormorolo = _interopRequireDefault(require("./15_group_2022_11_09/borgoratto-mormorolo"));

var _borgoLares = _interopRequireDefault(require("./15_group_2022_11_09/borgo-lares"));

var _breno = _interopRequireDefault(require("./15_group_2022_11_09/breno"));

var _bresimo = _interopRequireDefault(require("./15_group_2022_11_09/bresimo"));

var _caldaroSullaStradaDelVino = _interopRequireDefault(require("./15_group_2022_11_09/caldaro-sulla-strada-del-vino"));

var _caldes = _interopRequireDefault(require("./15_group_2022_11_09/caldes"));

var _caldonazzo = _interopRequireDefault(require("./15_group_2022_11_09/caldonazzo"));

var _camisano = _interopRequireDefault(require("./15_group_2022_11_09/camisano"));

var _campagnaLupia = _interopRequireDefault(require("./15_group_2022_11_09/campagna-lupia"));

var _campagnolaEmilia = _interopRequireDefault(require("./15_group_2022_11_09/campagnola-emilia"));

var _canazei = _interopRequireDefault(require("./15_group_2022_11_09/canazei"));

var _capannoli = _interopRequireDefault(require("./15_group_2022_11_09/capannoli"));

var _capoDiPonte = _interopRequireDefault(require("./15_group_2022_11_09/capo-di-ponte"));

var _cappellaDePicenardi = _interopRequireDefault(require("./15_group_2022_11_09/cappella-de-picenardi"));

var _capralba = _interopRequireDefault(require("./15_group_2022_11_09/capralba"));

var _capriana = _interopRequireDefault(require("./15_group_2022_11_09/capriana"));

var _carbonaraAlTicino = _interopRequireDefault(require("./15_group_2022_11_09/carbonara-al-ticino"));

var _casalattico = _interopRequireDefault(require("./15_group_2022_11_09/casalattico"));

var _castagnaro = _interopRequireDefault(require("./15_group_2022_11_09/castagnaro"));

var _castelDArio = _interopRequireDefault(require("./15_group_2022_11_09/castel-d-ario"));

var _castelGabbiano = _interopRequireDefault(require("./15_group_2022_11_09/castel-gabbiano"));

var _castelnovoDiSotto = _interopRequireDefault(require("./15_group_2022_11_09/castelnovo-di-sotto"));

var _castiglioneDelleStiviere = _interopRequireDefault(require("./15_group_2022_11_09/castiglione-delle-stiviere"));

var _cavalese = _interopRequireDefault(require("./15_group_2022_11_09/cavalese"));

var _cecima = _interopRequireDefault(require("./15_group_2022_11_09/cecima"));

var _ceneselli = _interopRequireDefault(require("./15_group_2022_11_09/ceneselli"));

var _cerignale = _interopRequireDefault(require("./15_group_2022_11_09/cerignale"));

var _cerretoDiSpoleto = _interopRequireDefault(require("./15_group_2022_11_09/cerreto-di-spoleto"));

var _cervino = _interopRequireDefault(require("./15_group_2022_11_09/cervino"));

var _chienes = _interopRequireDefault(require("./15_group_2022_11_09/chienes"));

var _cingiaDeBotti = _interopRequireDefault(require("./15_group_2022_11_09/cingia-de-botti"));

var _collepardo = _interopRequireDefault(require("./15_group_2022_11_09/collepardo"));

var _collio = _interopRequireDefault(require("./15_group_2022_11_09/collio"));

var _comanoTerme = _interopRequireDefault(require("./15_group_2022_11_09/comano-terme"));

var _comeglians = _interopRequireDefault(require("./15_group_2022_11_09/comeglians"));

var _commessaggio = _interopRequireDefault(require("./15_group_2022_11_09/commessaggio"));

var _concaDellaCampania = _interopRequireDefault(require("./15_group_2022_11_09/conca-della-campania"));

var _concesio = _interopRequireDefault(require("./15_group_2022_11_09/concesio"));

var _cormons = _interopRequireDefault(require("./15_group_2022_11_09/cormons"));

var _cornoDiRosazzo = _interopRequireDefault(require("./15_group_2022_11_09/corno-di-rosazzo"));

var _corteDeFrati = _interopRequireDefault(require("./15_group_2022_11_09/corte-de-frati"));

var _curonVenosta = _interopRequireDefault(require("./15_group_2022_11_09/curon-venosta"));

var _curtarolo = _interopRequireDefault(require("./15_group_2022_11_09/curtarolo"));

var _derovere = _interopRequireDefault(require("./15_group_2022_11_09/derovere"));

var _dimaroFolgarida = _interopRequireDefault(require("./15_group_2022_11_09/dimaro-folgarida"));

var _faedis = _interopRequireDefault(require("./15_group_2022_11_09/faedis"));

var _faiDellaPaganella = _interopRequireDefault(require("./15_group_2022_11_09/fai-della-paganella"));

var _falcade = _interopRequireDefault(require("./15_group_2022_11_09/falcade"));

var _fiave = _interopRequireDefault(require("./15_group_2022_11_09/fiave"));

var _fiesco = _interopRequireDefault(require("./15_group_2022_11_09/fiesco"));

var _fonzaso = _interopRequireDefault(require("./15_group_2022_11_09/fonzaso"));

var _fortunago = _interopRequireDefault(require("./15_group_2022_11_09/fortunago"));

var _fosciandora = _interopRequireDefault(require("./15_group_2022_11_09/fosciandora"));

var _fossatoDiVico = _interopRequireDefault(require("./15_group_2022_11_09/fossato-di-vico"));

var _funes = _interopRequireDefault(require("./15_group_2022_11_09/funes"));

var _gais = _interopRequireDefault(require("./15_group_2022_11_09/gais"));

var _giovo = _interopRequireDefault(require("./15_group_2022_11_09/giovo"));

var _golferenzo = _interopRequireDefault(require("./15_group_2022_11_09/golferenzo"));

var _grazzanise = _interopRequireDefault(require("./15_group_2022_11_09/grazzanise"));

var _isera = _interopRequireDefault(require("./15_group_2022_11_09/isera"));

var _lavenone = _interopRequireDefault(require("./15_group_2022_11_09/lavenone"));

var _lusevera = _interopRequireDefault(require("./15_group_2022_11_09/lusevera"));

var _madignano = _interopRequireDefault(require("./15_group_2022_11_09/madignano"));

var _male = _interopRequireDefault(require("./15_group_2022_11_09/male"));

var _malonno = _interopRequireDefault(require("./15_group_2022_11_09/malonno"));

var _marmentino = _interopRequireDefault(require("./15_group_2022_11_09/marmentino"));

var _martello = _interopRequireDefault(require("./15_group_2022_11_09/martello"));

var _medole = _interopRequireDefault(require("./15_group_2022_11_09/medole"));

var _menconico = _interopRequireDefault(require("./15_group_2022_11_09/menconico"));

var _mongrassano = _interopRequireDefault(require("./15_group_2022_11_09/mongrassano"));

var _monguelfoTesido = _interopRequireDefault(require("./15_group_2022_11_09/monguelfo-tesido"));

var _montasola = _interopRequireDefault(require("./15_group_2022_11_09/montasola"));

var _montecreto = _interopRequireDefault(require("./15_group_2022_11_09/montecreto"));

var _monteleoneDiSpoleto = _interopRequireDefault(require("./15_group_2022_11_09/monteleone-di-spoleto"));

var _monterotondoMarittimo = _interopRequireDefault(require("./15_group_2022_11_09/monterotondo-marittimo"));

var _montesegale = _interopRequireDefault(require("./15_group_2022_11_09/montesegale"));

var _moscazzano = _interopRequireDefault(require("./15_group_2022_11_09/moscazzano"));

var _mura = _interopRequireDefault(require("./15_group_2022_11_09/mura"));

var _niardo = _interopRequireDefault(require("./15_group_2022_11_09/niardo"));

var _ottone = _interopRequireDefault(require("./15_group_2022_11_09/ottone"));

var _ovaro = _interopRequireDefault(require("./15_group_2022_11_09/ovaro"));

var _paitone = _interopRequireDefault(require("./15_group_2022_11_09/paitone"));

var _palazzoPignano = _interopRequireDefault(require("./15_group_2022_11_09/palazzo-pignano"));

var _palazzuoloSulSenio = _interopRequireDefault(require("./15_group_2022_11_09/palazzuolo-sul-senio"));

var _paluzza = _interopRequireDefault(require("./15_group_2022_11_09/paluzza"));

var _parcines = _interopRequireDefault(require("./15_group_2022_11_09/parcines"));

var _pastorano = _interopRequireDefault(require("./15_group_2022_11_09/pastorano"));

var _paularo = _interopRequireDefault(require("./15_group_2022_11_09/paularo"));

var _pentone = _interopRequireDefault(require("./15_group_2022_11_09/pentone"));

var _perticaBassa = _interopRequireDefault(require("./15_group_2022_11_09/pertica-bassa"));

var _pessinaCremonese = _interopRequireDefault(require("./15_group_2022_11_09/pessina-cremonese"));

var _petriano = _interopRequireDefault(require("./15_group_2022_11_09/petriano"));

var _pieveFosciana = _interopRequireDefault(require("./15_group_2022_11_09/pieve-fosciana"));

var _pieveSanGiacomo = _interopRequireDefault(require("./15_group_2022_11_09/pieve-san-giacomo"));

var _pocenia = _interopRequireDefault(require("./15_group_2022_11_09/pocenia"));

var _pomponesco = _interopRequireDefault(require("./15_group_2022_11_09/pomponesco"));

var _pontebba = _interopRequireDefault(require("./15_group_2022_11_09/pontebba"));

var _pontecchioPolesine = _interopRequireDefault(require("./15_group_2022_11_09/pontecchio-polesine"));

var _pontevico = _interopRequireDefault(require("./15_group_2022_11_09/pontevico"));

var _ponza = _interopRequireDefault(require("./15_group_2022_11_09/ponza"));

var _porpetto = _interopRequireDefault(require("./15_group_2022_11_09/porpetto"));

var _pozzaglioEdUniti = _interopRequireDefault(require("./15_group_2022_11_09/pozzaglio-ed-uniti"));

var _prataSannita = _interopRequireDefault(require("./15_group_2022_11_09/prata-sannita"));

var _predaia = _interopRequireDefault(require("./15_group_2022_11_09/predaia"));

var _predazzo = _interopRequireDefault(require("./15_group_2022_11_09/predazzo"));

var _predoi = _interopRequireDefault(require("./15_group_2022_11_09/predoi"));

var _prepotto = _interopRequireDefault(require("./15_group_2022_11_09/prepotto"));

var _preseglie = _interopRequireDefault(require("./15_group_2022_11_09/preseglie"));

var _provaglioValSabbia = _interopRequireDefault(require("./15_group_2022_11_09/provaglio-val-sabbia"));

var _ragogna = _interopRequireDefault(require("./15_group_2022_11_09/ragogna"));

var _ravascletto = _interopRequireDefault(require("./15_group_2022_11_09/ravascletto"));

var _raviscanina = _interopRequireDefault(require("./15_group_2022_11_09/raviscanina"));

var _resiutta = _interopRequireDefault(require("./15_group_2022_11_09/resiutta"));

var _rigolato = _interopRequireDefault(require("./15_group_2022_11_09/rigolato"));

var _robeccoDOglio = _interopRequireDefault(require("./15_group_2022_11_09/robecco-d-oglio"));

var _roccaSusella = _interopRequireDefault(require("./15_group_2022_11_09/rocca-susella"));

var _roccaromana = _interopRequireDefault(require("./15_group_2022_11_09/roccaromana"));

var _rotzo = _interopRequireDefault(require("./15_group_2022_11_09/rotzo"));

var _sabbioneta = _interopRequireDefault(require("./15_group_2022_11_09/sabbioneta"));

var _salisano = _interopRequireDefault(require("./15_group_2022_11_09/salisano"));

var _sanBassano = _interopRequireDefault(require("./15_group_2022_11_09/san-bassano"));

var _sanBellino = _interopRequireDefault(require("./15_group_2022_11_09/san-bellino"));

var _sanCandido = _interopRequireDefault(require("./15_group_2022_11_09/san-candido"));

var _sanDanieleDelFriuli = _interopRequireDefault(require("./15_group_2022_11_09/san-daniele-del-friuli"));

var _sanGiovanniBianco = _interopRequireDefault(require("./15_group_2022_11_09/san-giovanni-bianco"));

var _sanGregorioNelleAlpi = _interopRequireDefault(require("./15_group_2022_11_09/san-gregorio-nelle-alpi"));

var _sanMartinoDelLago = _interopRequireDefault(require("./15_group_2022_11_09/san-martino-del-lago"));

var _santApollinare = _interopRequireDefault(require("./15_group_2022_11_09/sant-apollinare"));

var _sarmede = _interopRequireDefault(require("./15_group_2022_11_09/sarmede"));

var _scena = _interopRequireDefault(require("./15_group_2022_11_09/scena"));

var _scheggino = _interopRequireDefault(require("./15_group_2022_11_09/scheggino"));

var _schivenoglia = _interopRequireDefault(require("./15_group_2022_11_09/schivenoglia"));

var _sellero = _interopRequireDefault(require("./15_group_2022_11_09/sellero"));

var _senales = _interopRequireDefault(require("./15_group_2022_11_09/senales"));

var _seniga = _interopRequireDefault(require("./15_group_2022_11_09/seniga"));

var _serravalleAPo = _interopRequireDefault(require("./15_group_2022_11_09/serravalle-a-po"));

var _sesto = _interopRequireDefault(require("./15_group_2022_11_09/sesto"));

var _sgonico = _interopRequireDefault(require("./15_group_2022_11_09/sgonico"));

var _socchieve = _interopRequireDefault(require("./15_group_2022_11_09/socchieve"));

var _sottoIlMonteGiovanniXxiii = _interopRequireDefault(require("./15_group_2022_11_09/sotto-il-monte-giovanni-xxiii"));

var _sover = _interopRequireDefault(require("./15_group_2022_11_09/sover"));

var _sulzano = _interopRequireDefault(require("./15_group_2022_11_09/sulzano"));

var _sustinente = _interopRequireDefault(require("./15_group_2022_11_09/sustinente"));

var _tavernolaBergamasca = _interopRequireDefault(require("./15_group_2022_11_09/tavernola-bergamasca"));

var _tavernoleSulMella = _interopRequireDefault(require("./15_group_2022_11_09/tavernole-sul-mella"));

var _ton = _interopRequireDefault(require("./15_group_2022_11_09/ton"));

var _trevisoBresciano = _interopRequireDefault(require("./15_group_2022_11_09/treviso-bresciano"));

var _trivignanoUdinese = _interopRequireDefault(require("./15_group_2022_11_09/trivignano-udinese"));

var _valDellaTorre = _interopRequireDefault(require("./15_group_2022_11_09/val-della-torre"));

var _valfloriana = _interopRequireDefault(require("./15_group_2022_11_09/valfloriana"));

var _valladaAgordina = _interopRequireDefault(require("./15_group_2022_11_09/vallada-agordina"));

var _verolavecchia = _interopRequireDefault(require("./15_group_2022_11_09/verolavecchia"));

var _verzegnis = _interopRequireDefault(require("./15_group_2022_11_09/verzegnis"));

var _vescovato = _interopRequireDefault(require("./15_group_2022_11_09/vescovato"));

var _villachiara = _interopRequireDefault(require("./15_group_2022_11_09/villachiara"));

var _villamarzana = _interopRequireDefault(require("./15_group_2022_11_09/villamarzana"));

var _villanterio = _interopRequireDefault(require("./15_group_2022_11_09/villanterio"));

var _villeDAnaunia = _interopRequireDefault(require("./15_group_2022_11_09/ville-d-anaunia"));

var _voltido = _interopRequireDefault(require("./15_group_2022_11_09/voltido"));

var _zandobbio = _interopRequireDefault(require("./15_group_2022_11_09/zandobbio"));

var _zavattarello = _interopRequireDefault(require("./15_group_2022_11_09/zavattarello"));

var _zinasco = _interopRequireDefault(require("./15_group_2022_11_09/zinasco"));

var _zuglio = _interopRequireDefault(require("./15_group_2022_11_09/zuglio"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = _objectSpread({}, _abbiategrasso["default"], {}, _acquiTerme["default"], {}, _agnosine["default"], {}, _agosta["default"], {}, _ailano["default"], {}, _albiano["default"], {}, _amblarDon["default"], {}, _annoneVeneto["default"], {}, _arianoNelPolesine["default"], {}, _arsie["default"], {}, _avio["default"], {}, _bagnaria["default"], {}, _bagnoloCremasco["default"], {}, _baiaELatina["default"], {}, _balestrino["default"], {}, _barbianello["default"], {}, _barbiano["default"], {}, _bertiolo["default"], {}, _berzoDemo["default"], {}, _bibbiena["default"], {}, _bione["default"], {}, _bolano["default"], {}, _bolognola["default"], {}, _bonemerse["default"], {}, _borgorattoMormorolo["default"], {}, _borgoLares["default"], {}, _breno["default"], {}, _bresimo["default"], {}, _caldaroSullaStradaDelVino["default"], {}, _caldes["default"], {}, _caldonazzo["default"], {}, _camisano["default"], {}, _campagnaLupia["default"], {}, _campagnolaEmilia["default"], {}, _canazei["default"], {}, _capannoli["default"], {}, _capoDiPonte["default"], {}, _cappellaDePicenardi["default"], {}, _capralba["default"], {}, _capriana["default"], {}, _carbonaraAlTicino["default"], {}, _casalattico["default"], {}, _castagnaro["default"], {}, _castelDArio["default"], {}, _castelGabbiano["default"], {}, _castelnovoDiSotto["default"], {}, _castiglioneDelleStiviere["default"], {}, _cavalese["default"], {}, _cecima["default"], {}, _ceneselli["default"], {}, _cerignale["default"], {}, _cerretoDiSpoleto["default"], {}, _cervino["default"], {}, _chienes["default"], {}, _cingiaDeBotti["default"], {}, _collepardo["default"], {}, _collio["default"], {}, _comanoTerme["default"], {}, _comeglians["default"], {}, _commessaggio["default"], {}, _concaDellaCampania["default"], {}, _concesio["default"], {}, _cormons["default"], {}, _cornoDiRosazzo["default"], {}, _corteDeFrati["default"], {}, _curonVenosta["default"], {}, _curtarolo["default"], {}, _derovere["default"], {}, _dimaroFolgarida["default"], {}, _faedis["default"], {}, _faiDellaPaganella["default"], {}, _falcade["default"], {}, _fiave["default"], {}, _fiesco["default"], {}, _fonzaso["default"], {}, _fortunago["default"], {}, _fosciandora["default"], {}, _fossatoDiVico["default"], {}, _funes["default"], {}, _gais["default"], {}, _giovo["default"], {}, _golferenzo["default"], {}, _grazzanise["default"], {}, _isera["default"], {}, _lavenone["default"], {}, _lusevera["default"], {}, _madignano["default"], {}, _male["default"], {}, _malonno["default"], {}, _marmentino["default"], {}, _martello["default"], {}, _medole["default"], {}, _menconico["default"], {}, _mongrassano["default"], {}, _monguelfoTesido["default"], {}, _montasola["default"], {}, _montecreto["default"], {}, _monteleoneDiSpoleto["default"], {}, _monterotondoMarittimo["default"], {}, _montesegale["default"], {}, _moscazzano["default"], {}, _mura["default"], {}, _niardo["default"], {}, _ottone["default"], {}, _ovaro["default"], {}, _paitone["default"], {}, _palazzoPignano["default"], {}, _palazzuoloSulSenio["default"], {}, _paluzza["default"], {}, _parcines["default"], {}, _pastorano["default"], {}, _paularo["default"], {}, _pentone["default"], {}, _perticaBassa["default"], {}, _pessinaCremonese["default"], {}, _petriano["default"], {}, _pieveFosciana["default"], {}, _pieveSanGiacomo["default"], {}, _pocenia["default"], {}, _pomponesco["default"], {}, _pontebba["default"], {}, _pontecchioPolesine["default"], {}, _pontevico["default"], {}, _ponza["default"], {}, _porpetto["default"], {}, _pozzaglioEdUniti["default"], {}, _prataSannita["default"], {}, _predaia["default"], {}, _predazzo["default"], {}, _predoi["default"], {}, _prepotto["default"], {}, _preseglie["default"], {}, _provaglioValSabbia["default"], {}, _ragogna["default"], {}, _ravascletto["default"], {}, _raviscanina["default"], {}, _resiutta["default"], {}, _rigolato["default"], {}, _robeccoDOglio["default"], {}, _roccaSusella["default"], {}, _roccaromana["default"], {}, _rotzo["default"], {}, _sabbioneta["default"], {}, _salisano["default"], {}, _sanBassano["default"], {}, _sanBellino["default"], {}, _sanCandido["default"], {}, _sanDanieleDelFriuli["default"], {}, _sanGiovanniBianco["default"], {}, _sanGregorioNelleAlpi["default"], {}, _sanMartinoDelLago["default"], {}, _santApollinare["default"], {}, _sarmede["default"], {}, _scena["default"], {}, _scheggino["default"], {}, _schivenoglia["default"], {}, _sellero["default"], {}, _senales["default"], {}, _seniga["default"], {}, _serravalleAPo["default"], {}, _sesto["default"], {}, _sgonico["default"], {}, _socchieve["default"], {}, _sottoIlMonteGiovanniXxiii["default"], {}, _sover["default"], {}, _sulzano["default"], {}, _sustinente["default"], {}, _tavernolaBergamasca["default"], {}, _tavernoleSulMella["default"], {}, _ton["default"], {}, _trevisoBresciano["default"], {}, _trivignanoUdinese["default"], {}, _valDellaTorre["default"], {}, _valfloriana["default"], {}, _valladaAgordina["default"], {}, _verolavecchia["default"], {}, _verzegnis["default"], {}, _vescovato["default"], {}, _villachiara["default"], {}, _villamarzana["default"], {}, _villanterio["default"], {}, _villeDAnaunia["default"], {}, _voltido["default"], {}, _zandobbio["default"], {}, _zavattarello["default"], {}, _zinasco["default"], {}, _zuglio["default"]);

exports["default"] = _default;